import {z} from 'zod';

import {PHONE_NUMBER_REGEX_2} from '../../utils/validation';

const REQUIRED_FIELD_MESSAGE = 'This is a required field';

export const ticketSchema = z.object({
  firstName: z
    .string({message: REQUIRED_FIELD_MESSAGE})
    .trim()
    .min(1, {message: REQUIRED_FIELD_MESSAGE}),
  lastName: z
    .string({message: REQUIRED_FIELD_MESSAGE})
    .trim()
    .min(1, {message: REQUIRED_FIELD_MESSAGE}),
  email: z
    .string({message: REQUIRED_FIELD_MESSAGE})
    .min(1, {message: REQUIRED_FIELD_MESSAGE})
    .email({message: 'Please enter a valid email address'}),
  phoneNumber: z
    .string({message: REQUIRED_FIELD_MESSAGE})
    .min(1, {message: REQUIRED_FIELD_MESSAGE})
    .regex(PHONE_NUMBER_REGEX_2, {
      message: 'Please enter a valid Australian phone number',
    })
    .transform(val => val.replace(/[\s+]/g, '')), // Remove spaces and plus sign after validation
  nameOfStore: z
    .string({message: REQUIRED_FIELD_MESSAGE})
    .trim()
    .min(1, {message: REQUIRED_FIELD_MESSAGE}),
  enquiryType: z
    .string({message: REQUIRED_FIELD_MESSAGE})
    .trim()
    .min(1, {message: REQUIRED_FIELD_MESSAGE}),
  description: z
    .string({message: REQUIRED_FIELD_MESSAGE})
    .trim()
    .min(1, {message: REQUIRED_FIELD_MESSAGE}),
});

export type TicketFormData = z.infer<typeof ticketSchema>;

export {REQUIRED_FIELD_MESSAGE};
